import { Component, Injector } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mj_Detail } from '../mj_detail/mj_detail';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { HatComponent } from '../component/hat';
import { LancetsComponent } from '../component/lancets';
import { LineSvgComponent } from '../component/linesvg';
import { UserStarComponent } from '../component/userstar';
import { Confirm } from '../confirm/confirm';
import { Dashboard } from '../dashboard/dashboard';
import { DetailBadge } from '../detail_badge/detail_badge';
import { HrGraphCampionatiPage } from '../hr_graphcampionati/hr_graphcampionati';
import { HrProfiloUtentePage } from '../hr_profiloutente/hr_profiloutente';
import { HrListCampionatiPage } from '../hr_listcampionati/hr_listcampionati';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
/*@NgModule({
  imports: [RoundProgressModule]
})*/
@Component({
  selector: 'page-hr_profilosquadra',
  templateUrl: 'hr_profilosquadra.html',
})
export class HrProfiloSquadraPage extends Util {
  pagine: any;
  user: any;
  mjl: any;
  page: string;
  percent_hat = '20%';
  itemExpandHeight = 250;
  refresh_dashboard: boolean = false;
  squadra: any = {};
  pos: any = 0;
  campionato: any;
  girone: any;
  showCompletamento: any;
  showDownloadTracciati: boolean = false;
  premuto_filtra: boolean = false;
  filter_params: any = {};
  constructor(public navCtrl: NavController, public translate: TranslateService, public navParams: NavParams, injector: Injector, loading: LoadingController, hat: HatComponent, lancets: LancetsComponent, linesvg: LineSvgComponent, userstar: UserStarComponent) {
    super(injector, loading);
    this.user = this.navParams.get('user');
    this.squadra = this.navParams.get('squadra');
    this.pos = this.navParams.get('pos');
    this.campionato = this.navParams.get('campionato');
    this.girone = this.navParams.get('girone');

    this.showCompletamento = this.navParams.get('showCompletamento');
    this.showDownloadTracciati = this.navParams.get('showDownloadTracciati');
    this.premuto_filtra = this.navParams.get('premuto_filtra');
    this.filter_params = this.navParams.get('filter_params');
    // this.refreshpage();
  }
  open_profiloutente(utente, pos) {
    this.navCtrl.push(HrProfiloUtentePage, { utente: utente, pos: pos, numutenti: this.squadra.listUtenti.length, campionato: this.campionato, showDownloadTracciati: this.showDownloadTracciati });
  }
  // refreshpage() {
  //   this.GetRequest('microjourneyList', '').then(data => {

  //     //this.mjl = data['MicroJourneyList']['da_iniziare'];

  //     this.mjl = data['MicroJourneyList'];

  //     for (let i = 0; i < this.mjl.length; i++) {
  //       this.mjl[i].arr_expand = false;
  //       this.mjl[i].badge = [];
  //     }

  //     //console.log(this.mjl);
  //   }).catch((e) => {
  //     console.error(e)
  //   })
  // }

  open_campionato(campionato) {
    this.navCtrl.push(HrGraphCampionatiPage);
  }

  export() {
    if (this.premuto_filtra == false) {
      var req = 2 + '/' + this.campionato + '/' + this.girone + '/' + this.squadra.id;
      this.GetRequest('hr_esporta_grafico', req).then((x: any) => {
        //console.log(x);
        if (x != null && x.base64 != null) {
          const linkSource = `data:application/vnd.ms-excel;base64,${x.base64}`;
          const downloadLink = document.createElement("a");
          const fileName = "esportazione_squadra_eydlab.xls";

          downloadLink.href = linkSource;
          // downloadLink.target = '_blank';
          downloadLink.download = fileName;
          downloadLink.click();
        }
      }).catch((err) => {
        console.error(err);
      })
    }
    else {
      this.PostRequest('hr_esporta_grafico', '', { index: this.squadra.id, grafico_id: 2, cid: this.campionato, from_date: this.filter_params.from_date, to_date: this.filter_params.to_date, gironi: this.filter_params.gironi, mjs: this.filter_params.mjs, squadra_id: this.squadra.id }, true, true).then((x: any) => {
        // console.log(x);
        if (x != null && x.base64 != null) {
          const linkSource = `data:application/vnd.ms-excel;base64,${x.base64}`;
          const downloadLink = document.createElement("a");
          const fileName = "esportazione_squadra_eydlab.xls";

          downloadLink.href = linkSource;
          // downloadLink.target = '_blank';
          downloadLink.download = fileName;
          downloadLink.click();
        }
      }).catch((err) => {
        console.error(err);
      })
    }
  }


  back() {
    if (this.refresh_dashboard == false)
      this.navCtrl.pop({ animate: false });
    else
      this.go_root();
  }
  open_badge(i) {


    if (i.arr_expand == false) {
      this.GetRequest('badgeMJ', i.id).then(data => {
        i.badge = data['BadgeList'];
        //console.log(data);
        i.arr_expand = true;
      }).catch((e) => {
        //this.navCtrl.push(Mj_Detail,{mj:m});
        console.error(e)
      })

    }

    else
      i.arr_expand = false;

  }
  go_root() {
    this.navCtrl.setRoot(HrListCampionatiPage);
  }
  // reset_badge(item) {
  //   //console.log(item);
  //   this.presentPopover(event, Confirm, 'Stai per azzerare questo percorso: i tuoi progressi e i badge che hai raccolto verranno cancellati e tutte le statistiche saranno azzerate, con la sola esclusione del tempo di allenamento complessivo, vuoi procedere?').then((data) => {
  //     //console.log(data);
  //     if (data == 'confirm') {
  //       this.presentPopover(event, Confirm, 'Una volta data conferma i dati del percorso "'+item.nome+'" verranno definitivamente cancellati e non sarà più possibile recuperarli in alcun modo. Sei certo di voler azzerare questo percorso?', 'danger').then((data_) => {
  //         if (data_ == 'confirm') {
  //           this.PostRequest('resetMJ', item.id, {}, true, true).then(data_x => {
  //             this.refresh_dashboard = true; 
  //             //console.log(data_x);
  //             item.arr_expand = false;
  //           }).catch((e) => {
  //             //this.navCtrl.push(Mj_Detail,{mj:m});
  //             console.error(e)
  //           })
  //         }
  //       });
  //     }
  //   });


  // }
  show_detail_badge(b) {
    this.presentPopover(event, DetailBadge, b).then((data_) => {

    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/hr_profilosquadra/hr_profilosquadra.ts